import { useSideCart } from '@hooks/cart/useShoppingCart';
import Pin from '@monofront/design-system/visuals/Icons/Old/Pin';
import Button from '@monofront/design-system/components/Button';
import { useTranslations } from 'next-intl';
import { useEligibility } from '@monofront/business/contexts';
import { checkAddressSource } from '@context/shoppingCart';

const AddressSummary: React.FC = () => {
  const { address } = useEligibility();
  const { dispatchSideCart } = useSideCart();
  const tFresh = useTranslations('Fresh');

  return (
    address && (
      <>
        <div className="customer-address">
          <Pin />
          <p>
            {tFresh.rich('deliveryAt', {
              city: address.city,
              postalCode: address.postalCode,
              button: (children) => (
                <Button
                  block={false}
                  hasMinWidth={false}
                  size="small"
                  variant="link"
                  className="tw-lf-link-sm"
                  onClick={() =>
                    dispatchSideCart({
                      type: 'checkAddress',
                      openFromSideCart: true,
                      source: checkAddressSource.DEFAULT,
                    })
                  }
                  dataTestId="CartContent-button-address"
                >
                  {children}
                </Button>
              ),
            })}
          </p>
        </div>
        <style jsx>{`
          .customer-address {
            display: flex;
            align-items: center;
          }

          .customer-address :global(button) {
            font-size: var(--font-size-2);
          }

          @media (max-width: 800px) {
            .customer-address {
              padding: 0 var(--space-4);
              justify-content: center;
            }
          }
        `}</style>
      </>
    )
  );
};

export default AddressSummary;
